(function ($) {
  'use strict';

  /**
   * Form-validation related JS
   * We'll use the constructor to define all the langaue in the validator
   */
  function FormValidation() {
    this.validationMessageHeading = "Sorry, there's a problem";
    this.validationMessageSubHeading =
      'This page couldn’t be submitted as it contains {{ERRORS}}. Please review the following fields:';

    this.incompleteMessageHeading =
      'You have left some of the fields on this page empty';
    this.incompleteMessageSubHeading = `
      If you are sure the fields you have left empty don’t apply to you then you can mark these as ‘Not applicable’.<br /><br />
      If you're not sure, or know you need to complete them but don't have the information now, you can leave these empty and return to this page later.
      `;
    this.incompleteMessageSetAsNALabel = 'Mark as ‘Not applicable’';
    this.incompleteMessageLeaveEmptyLabel = 'Leave empty';
  }

  FormValidation.prototype = {
    init: function () {
      this.errors = [];
      this.incompleteFields = [];

      // Get the form
      this.$form = $('.js-form');

      // Stop the browser doing the validation
      this.$form.attr('novalidate', true);

      // Bind an function to the form submit event
      this.$form.on('submit', $.proxy(this.onFormSubmit, this));

      // Get the submit buttons and bind behaviour to them
      this.$submitButtons = $('button[name="submit-page"]');
      this.$submitButtons.on('click', $.proxy(this.onSubmitClick, this));
    },

    onFormSubmit: function (event) {
      event.preventDefault();
      this.disableFormSubmit();

      // Validate the form
      if (!this.validates()) {
        this.showValidationErrors();
      } else {
        this.hideValidationErrors();

        // Now look for fields which are empty and not N/A
        if (!this.isComplete()) {
          this.showIncompleteMessage();
        } else {
          this.submitForm();
        }
      }
    },

    // Update the value of the hidden _pageRouteType
    // field based on which button was clicked
    onSubmitClick: function (event) {
      var $eventTarget = $(event.target);
      if ($eventTarget.hasClass('js-submit-prev')) {
        $('input[name="_pageRouteType"]').val('previous');
      } else {
        $('input[name="_pageRouteType"]').val('next');
      }
    },

    // Unbind and submit
    submitForm: function () {
      this.$form.off('submit');
      this.$form.submit();
    },

    // First check for any fields which require client side validation
    validates: function () {
      // Reset the errors array
      this.errors = [];

      var noErrors = true;
      var self = this;
      var $numberFrequencyFields;
      var $requiredInputs;
      var $rangeInputs;
      var $theInput;
      var $theError;

      // Check all number frequency fields
      $numberFrequencyFields = this.$form.find(
        '[data-question-type="NumberFrequency"]'
      );

      $numberFrequencyFields.each(function () {
        var $numberInput = $(this).find('input[type="number"]');
        var $frequencyInput = $(this).find('select');

        // If this is zero and the frequency is empty
        if (
          parseFloat($numberInput.val()) === 0 &&
          $frequencyInput.val() === ''
        ) {
          $frequencyInput.val('Annually');
        }
      });

      // Get all the required inputs on this page
      $requiredInputs = this.$form.find(':input[required]:visible');

      // Check to see if all the required inputs have a value
      $requiredInputs.each(function () {
        $theInput = $(this);

        // If this has no value
        if (!self.hasValue($theInput)) {
          $theError = self.setError($theInput);
          self.errors.push($theError);
          noErrors = false;
        }
      });

      // Check all the min-max inputs
      $rangeInputs = this.$form.find(':input[min]:visible,:input[max]:visible');

      // Check to see if all the inputs with a Min OR Max validate
      $rangeInputs.each(function () {
        $theInput = $(this);

        if (!self.inRange($theInput)) {
          $theError = self.setError($theInput);
          self.errors.push($theError);
          noErrors = false;
        }
      });

      return noErrors;
    },

    // Go through every input which has a N/A options
    isComplete: function () {
      // Reset the incompleteFields array
      this.incompleteFields = [];

      var self = this;
      var allComplete = true;
      var $fieldGroups = $('.field-group');
      var $naDiv;
      var $naInput;
      var $theInput;
      var incompleteCount = 0;

      $fieldGroups.each(function () {
        // Look for a N/A div in this group
        $naDiv = $(this).find('.not-applicable');

        // If we found one…
        if ($naDiv.length) {
          $theInput = $(this).find('.field-group__field :input:not(button)');
          $naInput = $naDiv.find(':input');

          // console.log('--------------------------------');
          // console.log('Name: ' + $theInput.attr('name'));
          // console.log('Is visible: ' + $theInput.is(':visible'));
          // console.log('Has Value: ' + self.hasValue($theInput));
          // console.log('Is N/A: ' + self.hasValue($naInput));

          // If the field is visible AND is empty AND N/A is not checked?
          if (
            $theInput.is(':visible') &&
            !self.hasValue($theInput) &&
            !self.hasValue($naInput)
          ) {
            self.incompleteFields.push({ naInput: $naInput });
            incompleteCount++;
          }
        }
      });

      // console.log('incompleteCount: ' + incompleteCount);
      // console.log('fieldCount: ' + fieldCount);
      // console.log('naCount: ' + $naCount);

      // If we have any 'incomplete' fields
      // mark this page as 'incomplete'
      if (incompleteCount > 0) {
        allComplete = false;
      }

      return allComplete;
    },

    showValidationErrors: function () {
      // Remove any existing prompts
      $('.js-validation-prompt').remove();

      var $errorContainer = $('.js-validation-errors');
      var errorMessage = `
        <h3>${this.validationMessageHeading}</h3>
        <p>${this.validationMessageSubHeading}</p>
        `;

      // Update message with details of error count
      var errorDetails =
        this.errors.length + ' error' + (this.errors.length > 1 ? 's' : '');
      errorMessage = errorMessage.replace('{{ERRORS}}', errorDetails);

      $errorContainer.html(errorMessage);
      $errorContainer.append('<ol class="validation-summary__list">');
      $errorContainer.removeClass('u-hidden');

      for (var i = 0; i < this.errors.length; i++) {
        // Define the anchor for the validation message
        var $anchor;
        if (this.errors[i].group !== false) {
          $anchor = this.errors[i].group + '.container';
        } else {
          $anchor = this.errors[i].id.replace('value.confirm', 'container');
        }

        var $message = this.errors[i].message;
        var $error = $(
          `<li><a class="validation__link" href="#${$anchor}">${$message}</a></li>`
        );

        // Append the errors to the list
        $('.js-validation-errors ol').append($error);

        // -------------------------------------
        // Insert the prompt next to the input
        var $theInput = $('input[id="' + this.errors[i].id + '"]');
        $theInput
          .parent()
          .append(
            '<p class="validation-required js-validation-prompt">' +
              this.errors[i].prompt +
              '</p>'
          );
      }

      // Jump to the validation message
      window.location.href = '#validation-message';
      this.enableFormSubmit();
    },

    // Hide any visible errors and prompts before submitting
    hideValidationErrors: function () {
      $('.js-validation-errors').addClass('u-hidden');
      $('.js-validation-prompt').remove();
    },

    showIncompleteMessage: function () {
      var dialog = new Framework.Modal({
        mainEl: document.getElementById('container'), // The element to insert the modal HTML after
        id: 'formValidation', // A unique Id for this modal
        title: this.incompleteMessageHeading,
        description: this.incompleteMessageSubHeading,
        buttons: [
          {
            text: this.incompleteMessageLeaveEmptyLabel,
            className: 'btn--outline',
            close: true, // Whether or not this button will close the modal
            callback: () => {
              this.submitForm();
            },
          },
          {
            text: this.incompleteMessageSetAsNALabel,
            callback: () => {
              this.markFieldsAsNA();
            },
          },
        ],
      });

      // Show the dialog
      dialog.show();
      this.enableFormSubmit();
    },

    markFieldsAsNA: function () {
      for (var i = 0; i < this.incompleteFields.length; i++) {
        this.incompleteFields[i].naInput.click();
      }
      this.submitForm();
    },

    // Return a bool based on a value in the input
    hasValue: function ($theInput) {
      if ($theInput.is(':checkbox')) {
        return $theInput.prop('checked');
      } else {
        return !!$theInput.val();
      }
    },

    inRange: function ($theInput) {
      var InputDOMObj = $theInput.get(0);
      var theValue = $theInput.val();
      var theMin;
      var theMax;
      var isInRange = true;

      // If the input has a min attribute
      // is the value NOT less than it
      if (InputDOMObj.hasAttribute('min')) {
        theMin = $theInput.attr('min');
        if (theValue && parseInt(theValue) < theMin) {
          isInRange = false;
        }
      }

      // If the input has a max attribute
      // is the value NOT greater than it
      if (InputDOMObj.hasAttribute('max')) {
        theMax = $theInput.attr('max');
        if (theValue && parseInt(theValue) > theMax) {
          isInRange = false;
        }
      }

      return isInRange;
    },

    // Build an error object and push to errors array
    setError: function ($theInput) {
      var InputDOMObj = $theInput.get(0);
      var $theInputId = $theInput.attr('id');
      var $theValidationName = $theInput.data('validation-name');
      var $theValidationText = $theInput.data('validation-text');
      var $theValidationGroup = InputDOMObj.hasAttribute(
        'data-validation-group'
      )
        ? $theInput.data('validation-group')
        : false;

      return {
        id: $theInputId,
        message: this.setMessage(
          $theInputId,
          $theValidationName + ': ' + $theValidationText
        ),
        prompt: this.setPrompt($theInput),
        group: $theValidationGroup,
      };
    },

    // Either use the validation-text data attribute
    // or a custom message defined here
    setMessage: function (theInputId, $theValidationText) {
      switch (theInputId) {
        case 'your-savings_monthly-contribution-considered.value.confirm':
          return 'Please tick the box to confirm that a monthly contribution towards savings have been considered (or discussed with your adviser)';
        case 'assets_confirm-assets-lump-sum-payment.value.confirm':
          return 'Please tick the box to confirm you have considered the use of any assets to make lump sum payment';
        default:
          return $theValidationText;
      }
    },

    setPrompt: function ($theInput) {
      if ($theInput.is(':checkbox')) {
        return 'Please tick this box';
      } else {
        return 'Please check this field';
      }
    },

    /**
     * Disable form submission
     */
    disableFormSubmit: function () {
      this.$submitButtons.prop('disabled', true);
    },

    /**
     * Enable form submission
     */
    enableFormSubmit: function () {
      this.$submitButtons.prop('disabled', false);
    },

    /**
     * Update fields of type NumberFrequency to have a frequency
     * if the number is zero
     */
    setFrequencyForZeroAmounts: function () {},
  };

  this.FormValidation = FormValidation;
}.call(Framework, jQuery));
